import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as BulletActive } from 'assets/svg/icon-bullet-active.svg'

function IconBulletActive(props: IconProps): JSX.Element {
  const title = 'icon-bullet-active'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <BulletActive {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconBulletActive
